define([
    'jQuery',
    'underscore',
    'library/fcse-compatibility/object',
    'library/fcse-widget/widget'],
    function($, _, Object, Widget) {
        
        var RatingWidget = function (element, options) {
            Widget.apply(this, arguments);
            
            //Set options
            var defaultOptions = {
                'activeClassName': 'is-active'
            };
            this.addOptions(defaultOptions, options);
            
            //Register click event handler
            this._registerClickEvent();
        };

        RatingWidget.prototype = $.extend(Object.create(Widget.prototype), {
            _registerClickEvent: function () {
                var self = this;
                $('[data-value]', this.element).on("click", function (e) {
                    var value = $(this).data('value');
                    if (self.value !== value) {
                        self.setValue(value);
                    }
                    e.preventDefault();
                });
            },
            setValueToUi: function () {
                var self = this;
                $('[data-value]', self.element).removeClass(self.option('activeClassName'));
                _.each($('[data-value]', self.element), function(btn, index){
                    var $btn = $(btn);
                    if(parseFloat($btn.attr('data-value')) <= parseFloat(self.value)){
                        $btn.addClass(self.option('activeClassName'));
                    }
                });
            },
            getValueFromUi: function () {
                var active = $('[data-fcse-role="ratingwidget--bar"]').find("." + this.option('activeClassName') + ":last");
                if (active.length === 0) {
                    return null;
                }
                else {
                    return active.attr('data-value');
                }
            }
        });

        return RatingWidget;
    }
);


//////////////////
// WEBPACK FOOTER
// ./~/fcse-ratingwidget/ratingWidget.js
// module id = 87
// module chunks = 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21